import { TFunction } from "i18n";
import {
  IFilterStats,
  IFilterValues,
  IGetFilterFieldConfig,
} from "../../../types";
import { IDropdownCheckboxValueItemConfig } from "../../../../../Molecules/DropdownCheckbox/DropdownCheckboxValue";
import { getCheckboxGroupComponents } from "./getCheckboxGroupComponents";

export interface IGetCheckboxFilterWithOptions
  extends IGetFilterFieldConfig<IFilterValues> {
  getOptions: (t: TFunction) => IDropdownCheckboxValueItemConfig[];
  getOptionsWithStats?: (
    t: TFunction,
    stats?: IFilterStats
  ) => IDropdownCheckboxValueItemConfig[];
}

export function getCheckboxFilterWithOptions({
  name,
  values,
  filterDrawerValues,
  setFilterValues,
  setFilterDrawerValues,
  modifiers = {},
  t,
  dataTestId,
  stats,
  getOptions,
  getOptionsWithStats,
}: IGetCheckboxFilterWithOptions) {
  const fieldOptions = getOptions(t);
  const fieldOptionsWithStats = getOptionsWithStats?.(t, stats);

  const { filterControlComponent, filterDrawerConfig, tags } =
    getCheckboxGroupComponents({
      name,
      values,
      fieldOptions,
      fieldOptionsWithStats,
      filterDrawerValues,
      setFilterValues,
      setFilterDrawerValues,
      dataTestId,
      t,
    });

  return {
    tags,
    filterDrawerConfig,
    filterControlComponent: modifiers?.showFilterControl
      ? filterControlComponent
      : null,
  };
}
